module.exports = __webpack_public_path__ + "static/media/22ESCWA20.9d237e6b.jpg";